import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20sports%20stadium%20scene%20with%20dramatic%20warm%20golden%20and%20deep%20red%20lighting%2C%20flowing%20geometric%20patterns%20representing%20movement%20and%20competition%2C%20stylized%20silhouette%20of%20athletes%20in%20action%20across%20multiple%20sports%2C%20modern%20minimalist%20composition%20with%20dark%20background%20and%20vibrant%20energy%20accents%2C%20cinematic%20sports%20photography%20style%20with%20dynamic%20motion%20blur%20and%20atmospheric%20haze&width=1600&height=900&seq=hero-banner-haobo&orientation=landscape"
        alt="好博体育 - 专业体育竞技平台"
        title="好博体育官网 - 畅享全球赛事体验"
        className="absolute inset-0 w-full h-full object-cover"
        fetchPriority="high"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto text-center px-4">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 leading-tight">
          畅享全球顶级赛事体验
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 md:mb-10 max-w-[650px] mx-auto leading-relaxed">
          好博体育汇聚全球顶级赛事资源，提供足球、篮球、网球等多项运动的实时数据与专业分析，
          为广大体育爱好者打造极致的赛事体验平台。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about"
            className="px-8 py-3 bg-primary-500 text-white font-medium rounded-full hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            立即注册
          </Link>
          <Link
            to="/category/football"
            className="px-8 py-3 bg-white/15 backdrop-blur-sm text-white font-medium rounded-full hover:bg-white/25 transition-all border border-white/30 whitespace-nowrap"
          >
            查看赛事
          </Link>
        </div>

        <div className="flex items-center justify-center gap-6 md:gap-10 mt-10 md:mt-12">
          <div className="text-center">
            <span className="block text-2xl md:text-3xl font-heading font-bold text-accent-400">500+</span>
            <span className="text-xs md:text-sm text-white/60">每日赛事</span>
          </div>
          <div className="w-px h-8 bg-white/20"></div>
          <div className="text-center">
            <span className="block text-2xl md:text-3xl font-heading font-bold text-accent-400">50万+</span>
            <span className="text-xs md:text-sm text-white/60">活跃用户</span>
          </div>
          <div className="w-px h-8 bg-white/20"></div>
          <div className="text-center">
            <span className="block text-2xl md:text-3xl font-heading font-bold text-accent-400">98%</span>
            <span className="text-xs md:text-sm text-white/60">用户好评</span>
          </div>
        </div>
      </div>
    </section>
  );
}